"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalleeHelpers = exports.Callee = void 0;
var Callee;
(function (Callee) {
    Callee["Day"] = "Day";
    Callee["DayOfWeek"] = "DayOfWeek";
    Callee["Month"] = "Month";
    Callee["Year"] = "Year";
    Callee["Epoch"] = "Epoch";
    Callee["ParseTime"] = "ParseTime";
    Callee["Now"] = "Now";
    Callee["AddTime"] = "AddTime";
    Callee["TimeWithin"] = "TimeWithin";
    Callee["NextDay"] = "NextDay";
    Callee["UtcNow"] = "UtcNow";
    Callee["ToUtc"] = "ToUtc";
    Callee["DayOfWeekString"] = "DayOfWeekString";
    Callee["StartsWith"] = "StartsWith";
    Callee["EndsWith"] = "EndsWith";
    Callee["Contains"] = "Contains";
    Callee["Lower"] = "Lower";
    Callee["Upper"] = "Upper";
    Callee["Substring"] = "Substring";
    Callee["ParseLong"] = "ParseLong";
    Callee["LongToString"] = "LongToString";
    Callee["LongToInt"] = "LongToInt";
    Callee["ParseBool"] = "ParseBool";
    Callee["BoolToInt"] = "BoolToInt";
    Callee["ParseDouble"] = "ParseDouble";
    Callee["DoubleToString"] = "DoubleToString";
    Callee["GetLastSynapsePrediction"] = "GetLastSynapsePrediction";
    Callee["GetEventHistory"] = "GetEventHistory";
    Callee["GetEventSegmentHistory"] = "GetEventSegmentHistory";
    Callee["GetItemHistory"] = "GetItemHistory";
    Callee["GetItemsByMetaHistory"] = "GetItemsByMetaHistory";
    Callee["GetPurchaseRevenueHistory"] = "GetPurchaseRevenueHistory";
    Callee["GetPurchaseTransactionsHistory"] = "GetPurchaseTransactionsHistory";
    Callee["GetPackagePurchaseRevenueHistory"] = "GetPackagePurchaseRevenueHistory";
    Callee["GetPackagePurchaseTransactionsHistory"] = "GetPackagePurchaseTransactionsHistory";
    Callee["GetPurchaseRevenueHistoryByMeta"] = "GetPurchaseRevenueHistoryByMeta";
    Callee["GetPurchaseTransactionsHistoryByMeta"] = "GetPurchaseTransactionsHistoryByMeta";
    Callee["GetPurchaseRevenueHistoryByMetric"] = "GetPurchaseRevenueHistoryByMetric";
    Callee["GetPurchaseRevenueHistoryByMetricAndMeta"] = "GetPurchaseRevenueHistoryByMetricAndMeta";
    Callee["GetItemBalance"] = "GetItemBalance";
    Callee["Floor"] = "Floor";
    Callee["Round"] = "Round";
    Callee["Ceil"] = "Ceil";
    Callee["Sin"] = "Sin";
    Callee["Asin"] = "Asin";
    Callee["Cos"] = "Cos";
    Callee["Acos"] = "Acos";
    Callee["Tan"] = "Tan";
    Callee["Atan"] = "Atan";
    Callee["Exp"] = "Exp";
    Callee["Ln"] = "Ln";
    Callee["Log"] = "Log";
    Callee["Sqrt"] = "Sqrt";
    Callee["Pow"] = "Pow";
    Callee["Powf"] = "Powf";
    Callee["Trunc"] = "Trunc";
    Callee["Abs"] = "Abs";
    Callee["Fabs"] = "Fabs";
    Callee["Fmod"] = "Fmod";
    Callee["Min"] = "Min";
    Callee["Max"] = "Max";
    Callee["FMin"] = "FMin";
    Callee["FMax"] = "FMax";
    Callee["Rand"] = "Rand";
    Callee["Version"] = "Version";
    Callee["InSegment"] = "InSegment";
    Callee["Agg_Min"] = "Agg_Min";
    Callee["Agg_Max"] = "Agg_Max";
    Callee["Agg_Avg"] = "Agg_Avg";
    Callee["Agg_Count"] = "Agg_Count";
    Callee["Agg_Sum"] = "Agg_Sum";
    Callee["Agg_Percentile"] = "Agg_Percentile";
    Callee["Agg_Percentage"] = "Agg_Percentage";
    Callee["Agg_PercentageContains"] = "Agg_PercentageContains";
    Callee["ArrayInsert"] = "ArrayInsert";
    Callee["ArrayPop"] = "ArrayPop";
    Callee["ArrayCount"] = "ArrayCount";
    Callee["ArrayLength"] = "ArrayLength";
    Callee["JsonValue"] = "JsonValue";
    Callee["JsonValueDouble"] = "JsonValueDouble";
    Callee["JsonValueLong"] = "JsonValueLong";
    Callee["JsonValueBoolean"] = "JsonValueBoolean";
    Callee["JsonValueDate"] = "JsonValueDate";
    Callee["JsonObjectFold"] = "JsonObjectFold";
    Callee["JsonArraySort"] = "JsonArraySort";
    Callee["JsonArrayLength"] = "JsonArrayLength";
    Callee["JsonArrayFilter"] = "JsonArrayFilter";
    Callee["TeamVaultDateTimeMax"] = "TeamVaultDateTimeMax";
    Callee["TeamVaultDateTimeMin"] = "TeamVaultDateTimeMin";
    Callee["TeamVaultDoubleAvg"] = "TeamVaultDoubleAvg";
    Callee["TeamVaultDoubleMax"] = "TeamVaultDoubleMax";
    Callee["TeamVaultDoubleMin"] = "TeamVaultDoubleMin";
    Callee["TeamVaultDoubleSum"] = "TeamVaultDoubleSum";
    Callee["TeamVaultLongAvg"] = "TeamVaultLongAvg";
    Callee["TeamVaultLongMax"] = "TeamVaultLongMax";
    Callee["TeamVaultLongMin"] = "TeamVaultLongMin";
    Callee["TeamVaultLongSum"] = "TeamVaultLongSum";
    Callee["TeamVaultDateMax"] = "TeamVaultDateMax";
    Callee["TeamVaultDateMin"] = "TeamVaultDateMin";
    Callee["TeamVaultDateMapDateTimeMax"] = "TeamVaultDateMapDateTimeMax";
    Callee["TeamVaultDateMapDateTimeMin"] = "TeamVaultDateMapDateTimeMin";
    Callee["TeamVaultDateMapDoubleAvg"] = "TeamVaultDateMapDoubleAvg";
    Callee["TeamVaultDateMapDoubleMax"] = "TeamVaultDateMapDoubleMax";
    Callee["TeamVaultDateMapDoubleMin"] = "TeamVaultDateMapDoubleMin";
    Callee["TeamVaultDateMapDoubleSum"] = "TeamVaultDateMapDoubleSum";
    Callee["TeamVaultDateMapLongAvg"] = "TeamVaultDateMapLongAvg";
    Callee["TeamVaultDateMapLongMax"] = "TeamVaultDateMapLongMax";
    Callee["TeamVaultDateMapLongMin"] = "TeamVaultDateMapLongMin";
    Callee["TeamVaultDateMapLongSum"] = "TeamVaultDateMapLongSum";
    Callee["TeamVaultDateMapDateMax"] = "TeamVaultDateMapDateMax";
    Callee["TeamVaultDateMapDateMin"] = "TeamVaultDateMapDateMin";
    Callee["JsonTeamVault"] = "JsonTeamVault";
    Callee["TeamSize"] = "TeamSize";
    Callee["PrimaryIdentifier"] = "PrimaryIdentifier";
})(Callee = exports.Callee || (exports.Callee = {}));
var CalleeHelpers = (function () {
    function CalleeHelpers() {
    }
    CalleeHelpers.isValid = function (value) {
        return CalleeHelpers.all.indexOf(value) >= 0;
    };
    CalleeHelpers.all = [
        Callee.Day,
        Callee.DayOfWeek,
        Callee.Month,
        Callee.Year,
        Callee.Epoch,
        Callee.ParseTime,
        Callee.Now,
        Callee.AddTime,
        Callee.TimeWithin,
        Callee.NextDay,
        Callee.UtcNow,
        Callee.ToUtc,
        Callee.DayOfWeekString,
        Callee.StartsWith,
        Callee.EndsWith,
        Callee.Contains,
        Callee.Lower,
        Callee.Upper,
        Callee.Substring,
        Callee.ParseLong,
        Callee.LongToString,
        Callee.LongToInt,
        Callee.ParseBool,
        Callee.BoolToInt,
        Callee.ParseDouble,
        Callee.DoubleToString,
        Callee.GetLastSynapsePrediction,
        Callee.GetEventHistory,
        Callee.GetEventSegmentHistory,
        Callee.GetItemHistory,
        Callee.GetItemsByMetaHistory,
        Callee.GetPurchaseRevenueHistory,
        Callee.GetPurchaseTransactionsHistory,
        Callee.GetPackagePurchaseRevenueHistory,
        Callee.GetPackagePurchaseTransactionsHistory,
        Callee.GetPurchaseRevenueHistoryByMeta,
        Callee.GetPurchaseTransactionsHistoryByMeta,
        Callee.GetPurchaseRevenueHistoryByMetric,
        Callee.GetPurchaseRevenueHistoryByMetricAndMeta,
        Callee.GetItemBalance,
        Callee.Floor,
        Callee.Round,
        Callee.Ceil,
        Callee.Sin,
        Callee.Asin,
        Callee.Cos,
        Callee.Acos,
        Callee.Tan,
        Callee.Atan,
        Callee.Exp,
        Callee.Ln,
        Callee.Log,
        Callee.Sqrt,
        Callee.Pow,
        Callee.Powf,
        Callee.Trunc,
        Callee.Abs,
        Callee.Fabs,
        Callee.Fmod,
        Callee.Min,
        Callee.Max,
        Callee.FMin,
        Callee.FMax,
        Callee.Rand,
        Callee.Version,
        Callee.InSegment,
        Callee.Agg_Min,
        Callee.Agg_Max,
        Callee.Agg_Avg,
        Callee.Agg_Count,
        Callee.Agg_Sum,
        Callee.Agg_Percentile,
        Callee.Agg_Percentage,
        Callee.Agg_PercentageContains,
        Callee.ArrayInsert,
        Callee.ArrayPop,
        Callee.ArrayCount,
        Callee.ArrayLength,
        Callee.JsonValue,
        Callee.JsonValueDouble,
        Callee.JsonValueLong,
        Callee.JsonValueBoolean,
        Callee.JsonValueDate,
        Callee.JsonObjectFold,
        Callee.JsonArraySort,
        Callee.JsonArrayLength,
        Callee.JsonArrayFilter,
        Callee.TeamVaultDateTimeMax,
        Callee.TeamVaultDateTimeMin,
        Callee.TeamVaultDoubleAvg,
        Callee.TeamVaultDoubleMax,
        Callee.TeamVaultDoubleMin,
        Callee.TeamVaultDoubleSum,
        Callee.TeamVaultLongAvg,
        Callee.TeamVaultLongMax,
        Callee.TeamVaultLongMin,
        Callee.TeamVaultLongSum,
        Callee.TeamVaultDateMax,
        Callee.TeamVaultDateMin,
        Callee.TeamVaultDateMapDateTimeMax,
        Callee.TeamVaultDateMapDateTimeMin,
        Callee.TeamVaultDateMapDoubleAvg,
        Callee.TeamVaultDateMapDoubleMax,
        Callee.TeamVaultDateMapDoubleMin,
        Callee.TeamVaultDateMapDoubleSum,
        Callee.TeamVaultDateMapLongAvg,
        Callee.TeamVaultDateMapLongMax,
        Callee.TeamVaultDateMapLongMin,
        Callee.TeamVaultDateMapLongSum,
        Callee.TeamVaultDateMapDateMax,
        Callee.TeamVaultDateMapDateMin,
        Callee.JsonTeamVault,
        Callee.TeamSize,
        Callee.PrimaryIdentifier
    ];
    return CalleeHelpers;
}());
exports.CalleeHelpers = CalleeHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.octopus.common.Callee', {
    full: 'net.playq.octopus.common.Callee',
    short: 'Callee',
    package: 'net.playq.octopus.common',
    type: irt_1.IntrospectorTypes.Enum,
    options: CalleeHelpers.all
});
//# sourceMappingURL=Callee.js.map